import gsap from 'gsap';
import Dispatch from '../core/Dispatch';
import { COMPONENT_INIT } from '../lib/events';
import animatedScroll from '../lib/animatedScroll';
import Revealer from '../lib/Revealer';

export default el => {

    const map = el.querySelector('[data-map]');
    const mapSvgObject = map.querySelector('object');
    const municipalitySelect = el.querySelector('[data-municipality-select]');
    const municipalitySections = [...el.querySelectorAll('[data-sections] section')];

    let mapSvgDocument;

    const updateActiveMunicipalityInMap = (tween = true) => {
        if (!mapSvgDocument) {
            return;
        }

        let activeMunicipalitySlug;
        try {
            activeMunicipalitySlug = municipalitySelect._select.getValue();
        } catch (error) {
            console.error(error);
        }

        municipalitySections.forEach(section => {
            const { shape: shapeId } = section.dataset;
            const svgShape = mapSvgDocument.getElementById(shapeId);
            if (!svgShape) {
                console.warn(`Shape ${svgShape} not found`);
                return;
            }
            const isActive = section.id === activeMunicipalitySlug;
            const fill = isActive ? '#cccccc' : '#e6e6e6';
            if (tween) {
                gsap.to(svgShape, { fill, duration: 0.3 });
            } else {
                gsap.set(svgShape, { fill });
            }
        });
    };

    const setActiveMunicipality = (activeMunicipalitySlug, updateUrl = true) => {
        // Show and hide municipality sections
        municipalitySections.forEach(section => {
            section.hidden = activeMunicipalitySlug && activeMunicipalitySlug !== section.id;
            // Reset all reveals for hidden children
            if (section.hidden) {
                section.querySelectorAll('[data-revealed]').forEach(node => {
                    Revealer.reset(node);
                });
            }
        });

        // Set the value for the select
        try {
            municipalitySelect._select.setValue(activeMunicipalitySlug || '');
        } catch (error) {
            console.error(error);
        }

        // Maybe update the URL
        if (updateUrl) {
            let url;
            const segments = window.location.pathname.split('/').filter(Boolean);
            if (segments.length > 1) {
                url = `${window.location.origin}/${segments.slice(0, -1).join('/')}`;
            } else {
                url = `${window.location.origin}/${segments.join('/')}`;
            }
            if (activeMunicipalitySlug) {
                url += `/${activeMunicipalitySlug}`;
            }

            if (url !== window.location.href) {
                window.history.pushState(null, '', url);
            }
        }

        updateActiveMunicipalityInMap();
    };

    const onFireStationDotClick = e => {
        e.preventDefault();
        e.stopPropagation();

        const targetId = e.currentTarget.getAttribute('href').replace('#', '');
        const target = document.getElementById(targetId);

        setActiveMunicipality(e.currentTarget.dataset.municipality);

        if (!target) {
            return;
        }

        try {
            target.focus({ preventScroll: true });
        } catch (error) {
            console.error(error);
        }
        animatedScroll(target);
    };

    const onMunicipalitySelectChange = e => {
        const { value: activeMunicipalitySlug } = e.detail;
        setActiveMunicipality(activeMunicipalitySlug || null);
    };

    const onPopState = e => {
        const segments = window.location.pathname.split('/').filter(Boolean);
        setActiveMunicipality(segments[1] || null, false);
    };

    const onMapSvgLoaded = () => {
        mapSvgDocument = mapSvgObject.contentDocument;
        updateActiveMunicipalityInMap(false);
        gsap.to(map, {
            opacity: 1,
            duration: 0.3
        });
    };

    const init = () => {
        map.querySelectorAll('[data-firestations] a').forEach(link => {
            link.addEventListener('click', onFireStationDotClick);
        });

        municipalitySelect.addEventListener('change', onMunicipalitySelectChange);

        mapSvgObject.addEventListener('load', onMapSvgLoaded, { once: true });

        window.addEventListener('popstate', onPopState);

        Dispatch.emit(COMPONENT_INIT);
    };

    const destroy = () => {
        map.querySelectorAll('[data-firestations] a').forEach(link => {
            link.removeEventListener('click', onFireStationDotClick);
        });

        municipalitySelect.addEventListener('change', onMunicipalitySelectChange);

        window.addEventListener('popstate', onPopState);
    };

    return {
        init,
        destroy
    };

};
